import { navbarHeight } from 'constants/layout';

export const Flow = {
  baseStyle: () => ({
    height: `calc(100vh - ${navbarHeight}px)`,
    overflow: 'hidden',
    flexDirection: 'column',
  }),
};
